import axios from 'axios';
import { config } from '../config';
import { hasuraPath } from '../constants';

export const queryHasura = (
    headers: Record<string, string>,
    query: string,
    variables?: Record<string, unknown>,
) =>
    axios({
        baseURL: config.EEZYPAY_HASURA_HOST,
        headers,
        url: hasuraPath,
        method: 'post',
        data: {
            query,
            variables,
        },
    });
